import {createGetters, createMutations} from '@/lib/vuex';

const state = {
  // Shows warning for cookies
  cookieWarning: true,
};

const getters = {
  ...createGetters(['cookieWarning']),
};

const mutations = {
  ...createMutations(['cookieWarning']),
};

const actions = {
  ignoreCookieWarning({commit}) {
    commit('cookieWarning', false);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/website.js